export default function GetInvolved() {
  return (
    <>
      <h1>Get Involved</h1>
    </>
  );
}
